export const familyTrackingFeaturesList = [
    {
        id: '1',
        title: 'Live Location Sharing',
        content: 'See where your family members are in real time, whether they’re on their way home from school, heading to a friend’s house, or out running errands. Just open the app and get peace of mind at a glance, with no more constant check-in messages.',
        imgName: 'locationSharingCarousell'
    },
    {
        id: '2',
        title: 'Geofence Alerts',
        content: "Set up virtual boundaries around key places like school, work, or home, and get automatic notifications when a family member arrives or leaves",
        imgName: 'familyCarousel'
    },
    {
        id: '3',
        title: 'Speed Tracking',
        content: 'Perfect for families with teen drivers. See how fast they’re going and make sure they’re staying safe on the road. But remember, they can see how fast you’re going too!',
        imgName: 'trackMultiDevicesCarousell'
    },
    {
        id: '4',
        title: 'Check-In',
        content: 'Tell the group where you are and what you’re up to. It’s a way for family members to confirm they’ve arrived safely with just one tap',
        imgName: 'checkInCarousel'
    },
    {
        id: '5',
        title: 'Instant Messaging',
        content: "Family chats, plans and bad jokes, all in one place. No more bouncing between apps. With built-in messaging, you can share updates and coordinate schedules while seeing real-time locations. ",
        imgName: 'messegesCarousel'
    },
];